module.exports = __webpack_public_path__ + "static/media/view indent formmm.6c043204.svg";